<script>
import Edit from './Edit.vue'
export default {
  extends: Edit,
  created() {
    this.showModal = true
  },
  data() {
    return {
      updateScheduleId: ''
    }
  },
  computed: {
    title() {
      return 'Create Category'
    },
    getUri() {
      return ''
    },
    submitUri() {
      return `schedule-template/update/${this.updateScheduleId}`
    }
  },
  methods: {
    submit() {
      if (this.updateScheduleId == '') {
        this.$util.post('schedule-template/create', this.data, this.$el, {
          done: (response) => {
            if (!_.isUndefined(response.id)) {
              this.updateScheduleId = response.id
              this.afterCreated()
            } else {
              this.$util.notify({
                text: 'Scheduler id not found',
                status: 'error'
              })
            }
          }
        })
      } else {
        this.afterCreated()
      }
    },
    afterCreated() {
      this.submitForm(this.data, {
        done: () => {
          this.$emit('close')
          this.$emitter.emit('TableList.Refresh')
        }
      })
    }
  }
}
</script>
